export enum ColumnChangeStatus {
    New = 'new',
    Existing = 'existing',
    Removed = 'removed',
}
